export type Listener = (event: Event) => void;

export default abstract class ListenerProvider {
    public abstract registerListener(): void;

    public abstract unregisterListener(): void;
}
